import {
  AssetClass,
  BlotterType,
  Operator,
  QueryGroupImpl,
} from "../../shared/cubiq-model-multi-asset";
import { TableDefinition } from "../../shared/cubiq-services/model/TableDefinition";
import { BFXBLOTTERFILTERCONDITIONLABELS } from "./models/bfx-blotter-filter.constants";

export enum ExtendedOrderTypeIdentifier {
  OTHER,
  BENCHMARK,
  ALGO,
}
export enum FilterType {
  BlotterDefinition,
  BlotterFilter,
}
export const EXTENDED_TYPE_PROPERTY_NAME = "extendedTypeId";

export class BfxBlotterFilter {
  public filterIdentifier: BfxBlotterFilterId;
  public conditions: BfxBlotterFilterCondition[] = [];
  public queryGroup: QueryGroupImpl;
  public id: string;
  public extendedTypeId: ExtendedOrderTypeIdentifier | null;

  constructor(
    public filterId: string,
    public filterName: string,
    public createdBy: string,
    public createDateVal: number,
    public createDate: string,
    public favorite: boolean = false,
    public system: boolean = false,
  ) {
    // please see BfxBlotterFilterService.transform for a relevant factory
  }
}

export class BfxBlotterFilterId {
  constructor(public blotterType: BlotterType, public assetClass: AssetClass) {}
}

export class BfxBlotterFilterCondition {
  public conditionData: any;
  public operatorData: any;
  public prevCondition: any;
  public prevOperator: any;

  public to: any = null;
  public from: any = null;
  public altValue: any = null;
  public iconDisabled: boolean = false;

  constructor(
    public fieldName: string,
    public fieldTitle: string,
    operator: Operator,
    public value: any = null,
    public add: boolean = false,
    public or: boolean = false,
  ) {
    this.conditionData = { label: fieldTitle, value: fieldName };
    this.operatorData = BFXBLOTTERFILTERCONDITIONLABELS[operator];
    this.prevCondition = this.conditionData.value;
    this.prevOperator = this.operatorData ? this.operatorData.value : null;
  }
}

export class BfxBlotterFilterActionEvent {
  constructor(
    selectedFilter: BfxBlotterFilter,
    tableDefinition: TableDefinition,
    definitionsMap: any,
    service: any,
    field: string,
  ) {
    this._selectedFilter = selectedFilter;
    this._tableDef = tableDefinition;
    this._definitionsMap = definitionsMap;
    this._service = service;
    this._field = field;
  }
  public _selectedFilter: BfxBlotterFilter;
  public _tableDef: TableDefinition;
  public _definitionsMap: any;
  public _service: any;
  public _field: string;
}

export class BfxBlotterNewFilterActionEvent {
  constructor(callback: any, reset: boolean, service: any, field: string) {
    this._callback = callback;
    this._reset = reset;
    this._service = service;
    this._field = field;
  }
  public _callback: any;
  public _reset: boolean;
  public _service: any;
  public _field: string;
}
